<template>
    <div class="productCarousel">
        <ElementsCarouselBox
            v-for="(carousel, index) in carousels"
            :key="index"
            :title="carousel.title"
            :url="carousel.titleLink"
            :products="carousel.products"
            :item-list-name="`${itemListName}${index}`"
            :carousel-name="carousel.title"
            class="carouselBox--fullWidth"
        />
    </div>
</template>

<script lang="ts" setup>
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import { transformProductsToLuigisBoxItems } from '~/utils/transformProductsToLuigisBoxItems'
import Product from '~/models/Product/Product'

const props = defineProps<{
    carousels: { position: string; products: Product[]; title: string; titleLink: string }[]
}>()

onMounted(() => {
    props.carousels.forEach((carousel) => {
        LuigisBoxEventApi.sendRecommendationEvent(transformProductsToLuigisBoxItems(carousel.products), carousel.title, 'homepage_trends')
    })
})

const itemListName = GtmItemListNameEnum.HPStaticCarousel
</script>

<style lang="scss" scoped>
/*
Structure:
    .productCarousel
        .productCarousel__tabs
            .productCarousel__title
 */

.productCarousel {
    position: relative;
    max-width: $max-width-container-inside;
    margin: 2em auto;
}

.title {
    margin-right: 1em;
    font-size: 18px;
    color: $color-dark;
    padding-left: 0;
    font-weight: 500;

    a {
        color: $color-dark;

        &:hover {
            color: $color-cta;
        }
    }

    @media (min-width: 768px) {
        float: left;
        position: relative;
        z-index: 2;
    }
}
</style>

<style lang="scss" scoped>
.productCarousel .nav {
    flex-wrap: nowrap;
    overflow-x: auto;
}
</style>
